import dayjs from 'dayjs'
import {LocalDate} from '@enisco/mcc-react-lib'
import {IntlShape} from 'react-intl'

// Required because the expiration field is serialized from go time instead of our custom type
export const formatGoTime = (value: string | undefined, intl: IntlShape) => {
  if (!value) {
    return
  }
  const parsed = dayjs(value, 'YYYY-MM-DD[T]HH:mm.ss')
  return LocalDate.fromDayjs(parsed).format(intl)
}
